<template>
  <v-container fluid class="fill-height login-overlay">
    <div class="login">
      <div class="masked"></div>
      <div class="login__mask">
        <span>
          <div class="login__container">
            <div class="logo"></div>
            <v-form v-on:submit.prevent v-model="valid" ref="form">
              <input
                class="login__inputs"
                id="email"
                name="email"
                label="Email"
                placeholder="Username"
                type="email"
                v-model="email"
              />
              <input
                class="login__inputs"
                id="password"
                name="password"
                label="Enter your password"
                placeholder="Password"
                min="8"
                v-model="password"
                type="password"
              />
              <!-- <v-text-field :rules="passwordRules" counter required></v-text-field> -->
              <div class="login__footer">
                <div class="login__footer-content">
                  <a class="login__password-reset" @click="openResetModal()">Forgot Password?</a>
                  <v-btn
                    @click="login"
                    type="submit"
                    :class=" { 'login-btn white--text' : valid, disabled: !valid }"
                  >Sign In</v-btn>
                </div>
              </div>
            </v-form>
          </div>
        </span>
      </div>
    </div>
    <ResetRequestModal v-if="isOpen" v-on:close="closeResetModal()" />
    <ResetRequestConfirmModal v-if="isOpenConfirm" v-on:close="closeResetConfirmModal()" />
  </v-container>
</template>

<script>
import API from '../services/API';
import ResetRequestModal from '../components/PasswordResetRequestModal';
import ResetRequestConfirmModal from '../components/PasswordResetRequestConfirmModal';

export default {
  name: 'Login',
  components: { ResetRequestModal, ResetRequestConfirmModal },
  data() {
    return {
      email: '',
      password: '',
      isOpen: false,
      isOpenConfirm: false,
      valid: true,
    };
  },
  methods: {
    login() {
      API.post('/auth/login', {
        email: email._value,
        password: password._value,
      })
          .then((_res) => {
            this.$emit('login');
            this.$router.push({ path: '/' });
          })
          .catch((err) => {
            console.error(err);
          });
    },
    openResetModal() {
      this.isOpen = true;
    },
    closeResetModal() {
      this.isOpen = false;
      this.isOpenConfirm = true;
    },
    closeResetConfirmModal() {
      this.isOpenConfirm = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";

.masked {
  width: 100%;
  height: 100vh;
  background: var(--color-grey-light-1);
  background-image: url("../assets/img/train.jpg");
  background-size: cover;
  overflow: hidden;
  filter: blur(13px);
  -webkit-filter: blur(13px);
  -moz-filter: blur(13px);
  -o-filter: blur(13px);
  -ms-filter: blur(13px);
  top: 0;
  left: 0;
  position: absolute;
  clip: rect(0, 45vw, 100vh, 0);
}

.login {
  width: 45.5%;
  height: 100vh;

  &__mask {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;

    & > span {
      height: 50%;
      width: 100%;

      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
  }

  &-overlay {
    background: var(--color-grey-light-1);
    background-image: url("../assets/img/train.jpg");
    background-size: cover;
    overflow: hidden;
  }

  &__container {
    width: 31.6rem;
    height: 25rem;
    z-index: 100;

    .logo {
      display: block;
      margin: 0 auto 4rem auto;
      text-indent: -9999px;
      height: 4.9rem;
      width: 20rem;
      background: url("../assets/img/Logo.svg");
      background-size: 20rem 4.9rem;
    }
  }

  &__inputs {
    height: 39px;
    width: 316px;
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 6px;
    background-color: rgba(255, 255, 255, 0.2);
    font-family: Heebo;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
    padding-left: 25px;
    color: #ffffff;

    &::placeholder {
      color: #ffffff;
    }

    &:first-of-type {
      margin-bottom: 15px;
    }
  }

  &__footer {
    height: 68px;
    width: 100%;
    display: flex;
    align-items: flex-end;

    &-content {
      height: 45px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  &__password-reset {
    text-decoration: none;
    height: 24px;
    width: 137px;
    color: #ffffff;
    font-family: Heebo;
    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 24px;
    text-align: right;
  }

  &-btn {
    height: 44px;
    width: 129.22px;
    background-color: #cb201f !important;
    border-radius: 6px;
    color: #ffffff;
    font-family: Heebo;
    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 24px;
    text-align: center;
    text-transform: none;
  }

  @media only screen and (max-width: 1024px) {
    .masked {
      clip: rect(0, 100vw, 100vh, 0) !important;
    }

    .login__mask {
      width: 100vw;
    }
  }
}
</style>
